import { useState } from "react";
import { toast } from "sonner";
import { X } from "lucide-react";
import { useGet } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";
import { Section } from "@/components/app/Bits";
import { Button } from "@/components/ui/button";

export function ProductAliases({ pid }) {
  const { data, refetch } = useGet(`/inv/products/${pid}/aliases`);
  const vendors = useGet("/inv/meta").data?.vendors || [];
  const [f, setF] = useState({ vendor_id: "", text: "" });
  const act = async (body, msg) => { try { await api.post(`/inv/products/${pid}/aliases`, body); toast.success(msg); setF({ vendor_id: f.vendor_id, text: "" }); refetch(); } catch (e) { toast.error(errMsg(e)); } };
  if (!data) return null;
  return (
    <Section title="How vendors write it" testid="pd-aliases">
      <div className="card-surface p-4 space-y-3 text-sm">
        <p className="text-xs text-stone-500">Invoice lines with this wording from that vendor map to this product automatically. Aliases are vendor-specific.</p>
        {data.aliases.map((a) => (
          <div key={`${a.vendor_id}-${a.key}`} className="flex items-center gap-2" data-testid={`alias-${a.key}`}>
            <span className="flex-1">{`“${a.text}”`}<span className="text-xs text-stone-500">{` — ${a.vendor || "vendor"}${a.sku ? ` · #${a.sku}` : ""} · saved by ${a.by || "86'd"}`}</span></span>
            <button onClick={() => act({ remove_key: a.key, vendor_id: a.vendor_id }, "Alias removed")} aria-label="Remove alias" data-testid={`alias-remove-${a.key}`}><X className="h-4 w-4" /></button>
          </div>))}
        {!data.aliases.length && <div className="text-stone-500">No saved vendor wording yet — confirming invoice matches adds it.</div>}
        <div className="flex flex-wrap gap-2">
          <select className="h-10 rounded-lg border px-2" value={f.vendor_id} onChange={(e) => setF({ ...f, vendor_id: e.target.value })} data-testid="alias-vendor"><option value="">Vendor…</option>{vendors.map((v) => <option key={v.id} value={v.id}>{v.name}</option>)}</select>
          <input className="flex-1 min-w-[160px] h-10 rounded-lg border px-3" placeholder="e.g. BOMBAY SAPH 1000ML" value={f.text} onChange={(e) => setF({ ...f, text: e.target.value })} data-testid="alias-text" />
          <Button className="h-10" disabled={!f.vendor_id || !f.text.trim()} onClick={() => act(f, "Alias saved")} data-testid="alias-add">Add</Button>
        </div>
      </div>
    </Section>
  );
}
